export default {"src":"/_next/static/media/PurpleFaBriefcase.fc200619.svg","height":24,"width":25};